/**
 * Subcomponente reutilizable que muestra información visual de un equipo o jugador:
 * incluye una imagen (como bandera, logo o avatar) y el nombre asociado.
 */
export default function TeamInformation({ image, alt, name, className }) {
  return (
    <div className={className}>
      <img src={image} alt={alt} loading="lazy" />
      <p>{name}</p>
    </div>
  );
}